<!--
  Diamond layout template menu markup (mirrors the template's AppMenu / AppMenuitem output). Root
  entries with `items` render a static section header + a child list; entries without `items`
  (Login / Logout) render as standalone links. Styling comes from themes/diamond-layouts.scss.
-->
<ul class="layout-menu sidebar-menu">
  @for (node of model(); track node.label) {
    <li class="layout-root-menuitem" [class.sidebar-logout]="node.id === 'logout'">
      @if (node.items) {
        <div class="layout-menuitem-root-text">
          <span>{{ node.label }}</span>
          @if (node.id === 'my-supervisors') {
            <a
              class="section-header-action"
              [routerLink]="addSupervisorPath()"
              [queryParams]="sharedQueryParams()"
              aria-label="Add supervisor"
              title="Add supervisor"
            >
              <i class="pi pi-plus"></i>
            </a>
          }
        </div>
        <ul>
          @for (item of node.items; track item.routerLink ?? item.label) {
            <li>
              @if (item.disabled) {
                <a class="menuitem-muted">
                  <span class="layout-menuitem-text">{{ item.label }}</span>
                </a>
              } @else {
                <a
                  [ngClass]="item.styleClass"
                  [routerLink]="item.routerLink"
                  routerLinkActive="active-route"
                  [routerLinkActiveOptions]="item.routerLinkActiveOptions ?? { exact: false }"
                  [queryParams]="item.queryParams"
                >
                  <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
                  <span class="layout-menuitem-text">{{ item.label }}</span>
                </a>
              }
            </li>
          }
        </ul>
      } @else {
        <ul>
          <li>
            <a
              [routerLink]="node.routerLink"
              routerLinkActive="active-route"
              [routerLinkActiveOptions]="node.routerLinkActiveOptions ?? { exact: false }"
              [queryParams]="node.queryParams"
            >
              <i [ngClass]="node.icon" class="layout-menuitem-icon"></i>
              <span class="layout-menuitem-text">{{ node.label }}</span>
            </a>
          </li>
        </ul>
      }
    </li>
  }
</ul>
